export const get = async route => {
  try {
    const response = await fetch(`${AF_API_URL}${route}`)
    return response.json()
  } catch (e) {
    throw new Error(e)
  }
}
